var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-input',{staticClass:"searchInput",staticStyle:{"width":"200px"},attrs:{"value":_vm.searchText,"placeholder":"搜索","prefix-icon":"el-icon-search","size":"mini"},on:{"input":_vm.inputChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }